/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {combineEpics, Epic} from 'redux-observable';
import {delay, filter, map} from 'rxjs/operators';
import {isActionOf} from 'typesafe-actions';
import {notificationAdded, notificationHidden, notificationRemoved} from './actions';

export const autoHideNotifications: Epic = (action$) =>
	action$.pipe(
		filter(isActionOf(notificationAdded)),
		filter((action) => action.payload.autoClose),
		delay(5000),
		map((action) => notificationHidden({identifier: action.payload.notification.identifier}))
	);

export const autoCloseNotifications: Epic = (action$) =>
	action$.pipe(
		filter(isActionOf(notificationHidden)),
		delay(800),
		map((action) => notificationRemoved({identifier: action.payload.identifier}))
	);

export default combineEpics(autoHideNotifications, autoCloseNotifications);
